import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpContextToken,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AuthService } from '../modulos/auth/services/auth.service';
import { Router } from '@angular/router';
import { NO_API_KEY, skipApiKey } from './http.context';
import { AlertService } from 'src/app/services/alert.service';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { UsuarioState } from '../redux/usuario/usuario.reducer';
import { UsuarioRedux } from '../models/usuario.model';
import  * as userAccions from "./../redux/usuario/usuario.actions"
import { ConstantsService } from '../services/constants.service';

export const BYPASS_JWT_TOKEN = new HttpContextToken(() => false);

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  usuarioAppState: UsuarioState = null;
  usuarioRedux: UsuarioRedux = null;

  constructor(
    private authenticationService: AuthService,
    private router: Router,
    private alertService: AlertService,
    private store: Store<AppState>,
    private authService: AuthService,
  ) {
    
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    this.store.select('usuarioApp').subscribe(response =>{    
      this.usuarioAppState = response
      this.usuarioRedux = response.currentUser
    })
    
    const token = this.usuarioAppState.access_token
    if(token){
      if (request.context.get(BYPASS_JWT_TOKEN) === true) {
        // Here we can find out if the Http Call triggered wanted to skip the interceptor or not
        if (request.context.get(NO_API_KEY)) {
          // if enters it's because skipApiKey function was called for this request. Won't add the token
          return next.handle(request);
        }
        return next.handle(request);
      }       
        request = request.clone({
          setHeaders: {Authorization: `Bearer ${token}`},
        });


      
    }
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 || err.status === 403) {
          // this.authenticationService.logout();
          // this.router.navigateByUrl('/login/auth');
          this.authService.logout();
          this.store.dispatch(userAccions.logout())
        }

        if (err.status === 400) {
          this.alertService.warning('¡Atención!', err.error.detail);

        }

        if (err.status === 500) {
        }
        //return throwError(() => new Error(err.message))
        return throwError(err);
      })
    );
  }
}
